import { DateHelper } from "../../helper/date-helper";

/**
* Represents the active module object
*/
export class ActiveModule {
	constructor(name: string) {
		this.name = name !== "undefined" && name !== null ? name : "Unbekannt";
		this.timestamp = DateHelper.nowAsTicks();
	}

	public id: number;
	public name: string;
	public timestamp: number;
}